import { useQuery } from '@tanstack/react-query';

// Nager.Date public holiday API — free, no API key required
// Country codes: NG = Nigeria, GB = UK, GH = Ghana, ZA = South Africa, etc.
const COUNTRY_CODE = 'NG';

export function useGoogleHolidays(year) {
  return useQuery({
    queryKey: ['publicHolidays', COUNTRY_CODE, year],
    queryFn: async () => {
      const url = `https://date.nager.at/api/v3/PublicHolidays/${year}/${COUNTRY_CODE}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch public holidays');
      const data = await response.json();

      return (data || []).map(h => ({
        id: h.date,
        name: h.name,
        date: h.date, // already YYYY-MM-DD
      }));
    },
    enabled: !!year,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
    retry: false,
  });
}
